import { Issue, IssueSeverity, IssueTrend, RepositoryIssue } from '~/types/types'

export enum UiIssueLevel {
  Repository = 'repository',
  Check = 'check'
}

export function getRepositoryIssueProps({
  id,
  seenIn,
  occurrenceCount,
  autofixAvailable,
  trend,
  raisedInFiles,
  firstSeen,
  issueType,
  lastSeen,
  shortcode,
  title,
  tags,
  severity: severityString
}: RepositoryIssue) {
  return {
    id,
    seenIn,
    occurrenceCount,
    autofixAvailable,
    trend,
    raisedInFiles,
    firstSeen,
    issueType,
    lastSeen,
    shortcode,
    title,
    tags,
    severity: isValidIssueSeverity(severityString) ? severityString : IssueSeverity.Minor
  } as {
    id: string
    seenIn: string
    occurrenceCount: number
    autofixAvailable: boolean
    trend: IssueTrend
    raisedInFiles: string[]
    firstSeen: string
    issueType: string
    lastSeen: string
    shortcode: string
    title: string
    tags: string[]
    severity: IssueSeverity
  }
}

function isValidIssueSeverity(severity: string): severity is IssueSeverity {
  return Object.values(IssueSeverity).includes(severity as IssueSeverity)
}

export function getIssueProps({
  id,
  title,
  shortcode,
  issueType,
  severity,
  seenIn,
  occurrenceCount,
  autofixAvailable
}: Issue) {
  return {
    id,
    title,
    shortcode,
    issueType,
    severity,
    seenIn,
    occurrenceCount,
    autofixAvailable
  } as {
    id: string
    title: string
    shortcode: string
    issueType: string
    severity: IssueSeverity
    seenIn: string
    occurrenceCount: number
    autofixAvailable: boolean
  }
}
